// ─── countries.js ─────────────────────────────────────────────────────────────
// Single source of truth for all selectable countries.
// Add or remove countries here — nothing else needs to change.
// ─────────────────────────────────────────────────────────────────────────────

import {filterSelectableCountries} from '../../../utils/selectable-countries'
import {
  getCountryRegistry,
  subscribeToCountryRegistry,
} from '../../../utils/country-registry'

// Backend-driven: the list comes from the country registry (GET /api/countries,
// see src/utils/country-registry.js) — onboarding a country is a data change in
// ooe-service, not a code change here. COUNTRIES is updated IN PLACE when the
// registry loads so every static importer sees the new list; components that
// must re-render on load call useCountryRegistry().
const toOptions = () =>
  getCountryRegistry().map(c => ({code: c.iso, label: c.name}))

export const COUNTRIES = filterSelectableCountries(toOptions())

subscribeToCountryRegistry(() => {
  COUNTRIES.splice(
    0,
    COUNTRIES.length,
    ...filterSelectableCountries(toOptions()),
  )
})

export const DEFAULT_COUNTRY = 'US'

// Helper — get country by code
export const getCountry = code => COUNTRIES.find(c => c.code === code) ?? null
